<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script src="https://cdn.jsdelivr.net/npm/vue@2.6.14/dist/vue.js"></script>
<script>
export default {
  components: {},
  data() {
    return {};
  },
  methods: {},
  computed: {},
  created() {
  },
  mounted() {},
};
</script>
<style>
.el-time-spinner__item{
  height: 30px!important;
  line-height: 15px!important;
}

/* 移动端 el-message 样式优化 */
@media (max-width: 768px) {
  .el-message {
    min-width: 280px !important;
    max-width: 90vw !important;
    top: 60px !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
    padding: 12px 15px !important;
    font-size: 14px !important;
    box-sizing: border-box !important;
  }
  
  .el-message__content {
    font-size: 14px !important;
    line-height: 1.5 !important;
  }
  
  .el-message__icon {
    font-size: 16px !important;
  }
  
  .el-message__closeBtn {
    font-size: 16px !important;
  }
}
</style>
<style lang="less">

</style>
